import React, { useEffect, useState } from "react";

function ProgressBarComponent({ progress = 0 }) {
  const [animatedProgress, setAnimatedProgress] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimatedProgress(progress);
    }, 300);
    return () => clearTimeout(timeout);
  }, [progress]);

  return (
    <div className="tw-w-full tw-bg-gray-200 tw-rounded-full tw-h-5 tw-relative tw-overflow-hidden tw-mt-4 tw-shadow-inner">
      <div
        className="tw-bg-green-500 tw-h-full tw-rounded-full tw-transition-all tw-duration-700"
        style={{ width: `${animatedProgress}` }}
      ></div>
      <span className="tw-absolute tw-left-1/2 tw-top-1/2 tw-transform -tw-translate-x-1/2 -tw-translate-y-1/2 tw-text-white tw-text-sm tw-font-semibold">
        {animatedProgress}
      </span>
    </div>
  );
}

export default ProgressBarComponent;
